module.exports = __webpack_public_path__ + "184745f572b06cc7ef95e4a8de335d73.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_4_a.png
// module id = 46
// module chunks = 0